import { useEffect, useRef } from 'react';
import { consentAwareScript, enableTrackingAndAnalytics } from '../../consentManager/tagHelpers';

function addItemwiseTracking(): void {
  const itemwiseScript = consentAwareScript({ consentType: 'marketing', async: true });
  itemwiseScript.textContent = `(function(i,s,o,g,r,a,m){i['TrackuityObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','//the.itemwi.se/snippet.js','tty');
tty('auto', {key: '99Q8P9zuSnZrWHrX8Vr94d'});
tty('cookie-consent');`;
  document.head.append(itemwiseScript);
}

export default function WithTracking({ children }: { children: JSX.Element }): JSX.Element {
  const scriptsAdded = useRef(false);

  useEffect(() => {
    if (typeof document === 'undefined' || !enableTrackingAndAnalytics() || scriptsAdded.current) {
      return;
    }
    scriptsAdded.current = true;

    addItemwiseTracking();
  }, []);

  return children;
}
